import { Controller } from "@hotwired/stimulus"

// Keeps the search bar's two controls in sync with what the user is actually
// looking at. The search input and stat cards swap only the
// submissions-results frame, so render-time state goes stale in two places
// (decision-30 review):
//
// - the Filters button's slideover source — opening it would seed the form
//   with page-load filters and Apply would silently drop live narrowing
// - the search form's hidden filter fields — typing after a stat-card click
//   or chip removal would rebuild the frame URL from stale fields
//
// `sync` is bound to mousedown/keydown so it always runs before the click
// that slideover#open handles (same-event listener order across controllers
// is registration order, not attribute order — pointer-down beats click).
// `syncForm` is bound to input; frame-filter debounces its submit, so the
// rebuilt fields are in place before the form serializes.
export default class extends Controller {
  static targets = ["hiddenFields"]
  // Which results frame holds the live state. Defaults to the submissions
  // inbox's; the site inspections list (TASK-191.3) reuses this search bar
  // against its own frame. Without the value the lookup would silently miss
  // and fall back to the address bar — correct today only because
  // frame-filter replaceStates it, which is not a contract worth relying on.
  static values = { frame: { type: String, default: "submissions-results" } }

  sync() {
    const query = this.currentQuery()
    const base = (this.element.dataset.slideoverTurboFrameSrcValue || "").split("?")[0]
    if (base) this.element.dataset.slideoverTurboFrameSrcValue = base + query
  }

  syncForm() {
    if (!this.hasHiddenFieldsTarget) return

    const params = new URLSearchParams(this.currentQuery())
    params.delete("search")

    const fragment = document.createDocumentFragment()
    for (const [name, value] of params.entries()) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      input.value = value
      fragment.appendChild(input)
    }
    this.hiddenFieldsTarget.replaceChildren(fragment)
  }

  currentQuery() {
    const frame = document.getElementById(this.frameValue)
    const current = frame?.src || window.location.href
    const queryIndex = current.indexOf("?")
    return queryIndex >= 0 ? current.slice(queryIndex) : window.location.search
  }
}
